import React, {useEffect, useState} from "react"
import { FiArchive, FiAtSign, FiBold, FiChevronDown, FiChevronRight, FiCode, FiEdit2, FiFileText, FiHeadphones, FiItalic, FiLink, FiList, FiLogOut, FiMenu, FiMic, FiMoreVertical, FiPaperclip, FiPlus, FiSearch, FiSettings, FiSmile, FiTrash2, FiType, FiUser, FiUserPlus, FiUsers, FiVideo, FiVolume1, FiVolume2, FiVolumeX, FiX, FiZap } from "react-icons/fi"
import { URLRegex } from "../../../../utils/helper"
import clx from "classnames"
import { Header } from "./header"
import { useModal } from "../../../../stores/useModal"
import { Profile } from "../../../shared/profile"
import { Search } from "../../../shared/search"
import { Send } from "./send"
import teamStore from "../../../../stores/useTeam"
import { Empty } from "../../../shared/empty"
import { Spinner } from "../../../shared/spinner"
import { EmojiPicker } from "../../messsenger/content/emojipicker"
 
export const Conversations = ({
    messages,
    handle,
}) => {
    const {open} = useModal(state=>state)
    const [profile, setProfile] = useState(false);
    const {search} = teamStore(state=>state)


    
   const [delay, setDelay] = useState(false)

   useEffect(()=>{
    setTimeout(() => setDelay(true) , 1500)
    setDelay(false)
   },[messages])


    return (
        <React.Fragment>
            <div className="conversation h-full overflow-y-auto relative">
    
                <Header 
                    profile={profile}
                    setProfile={setProfile}
                />

                {profile && <Profile profile={profile} /> }
                
                {search &&  <Search />}

                {!profile && !search && (
                    <ul>
                        {messages.map((user,i)=> { 
        
                            if(user.event){
                            return (
                                <li>
                                <div className="cursor-pointer my-6 h-[1px] dark:bg-zinc-800 bg-gray-100 flex items-center justify-center">
                                    <div className="bg-[#fcfcfc] px-5 rounded-full p-1 -mt-1 text-sm text-gray-400 dark:text-gray-500 dark:bg-zinc-800">{user.event}</div>
                                </div>
                                </li>
                            )
                            }
                        
                        return (
                            <li>
                            <div class={
                                clx(`group relative flex gap-4 mx-5 hover:bg-gray-50 dark:hover:bg-zinc-900/20 
                                hover:border-b p-2`,
                                {'border-red-500':i==0},
                                {'border-orange-500':i==2},
                                {'border-blue-500':i==3},
                                {'border-green-500':i==4},
                                {'border-purple-500':i==5},
                                {'border-pink-500':i==6},
                                )
                            } >
                                <img
                                src={user.avatar}
                                className="w-14 h-14 object-contain rounded-full"
                                />
                                <div>
                                <div className="flex items-center gap-3">
                                    <div 
                                    style={{color:user.foreground}}
                                    className="font-bold text-[#a162ba]">{user.name}</div>
                                    <p className="text-gray-700 text-xs">Today at 9:18 AM</p>
                                </div>
                                {user.messages?.map(message=>{
        
        
                                    if(message?.type=='file'){
                                    return;
                                    }
        
        
                                    if(typeof message == 'string'){
                                    return (
                                        <div className="text-zinc-700 dark:text-gray-400">
            
                                        {message.split(' ').map((word,key)=>{

                                            if(word.match('@Mike')){
                                                return <span class="text-blue-700 dark:text-blue-400 mr-1 bg-blue-500/30 py-[1px] px-1 mx-[1px] rounded-md cursor-pointer" >{word}</span>
                                            }
                                            if(word.match('@Gamer')){
                                                return  <span class="text-yellow-700 dark:text-yellow-400 mr-1 bg-yellow-500/30 py-[1px] px-1 mx-[1px] rounded-md cursor-pointer" >{word}</span>
                                            }
                                            
                                            if(word?.match(URLRegex)) {
                                            return <a
                                            href="#"
                                            className="font-medium text-blue-500 mr-1"
                                            >{word}</a>
                                            }
                                            return `${word} `;
            
                                        }) }
            
                                        {user?.preview && (
                                            <div className="flex gap-2 bg-zinc-100 dark:bg-zinc-900 rounded-e-md w-full h-32 p-2 px-3 my-2 border-l-4 border-gray-300 dark:border-zinc-500 cursor-pointer overflow-hidden">
                                                <img
                                                src={user.preview.logo}
                                                className="h-10 w-10 mt-2 object-contain"
                                                />
                                                <div>
                                                <h1 className="font-semibold text-lg text-zinc-700 dark:text-zinc-400">{user.preview.title} </h1>
                                                <p className="text-gray-500 dark:text-gray-500 text-sm">{user.preview.description}</p>
                                                </div>
                                            </div>
                                        )}
            
                                    </div>
                                    )
                                    }
        
                                    return;
                                    
                                    
                                })}
        
        
                            {user?.files && (
                                <ul className="border border-gray-300 dark:border-zinc-700 rounded-md overflow-hidden my-5">
                                    {user.files.map((file,i)=>(
                                    <li className="text-gray-700 dark:text-gray-300 border-b border-gray-300 dark:border-zinc-700
                                    bg-gray-50 dark:bg-zinc-900 hover:bg-zinc-100 cursor-pointer p-2 px-3 flex justify-between items-center">
                                        <div className="flex gap-2">
                                            <FiFileText size={23}
                                            className="stroke-gray-500"
                                            />
                                            <p className="">{file.path}</p>
                                        </div>
                                        <div className="pl-3 flex items-center">
                                            <FiEdit2 size={23}
                                            className="stroke-gray-500 h-4"
                                            />
                                            <FiX size={23}
                                            className="stroke-gray-500 h-5"
                                            />
                                        </div>
                                    </li>
                                    ))}
                                </ul>
                            )}
        
                            </div>
                                <Actions id={user.id} handle={handle} />
                            </div>
                                {/**<!--EMOJI-ICON-->**/}
        
                                {user?.reactions && (
                                    <ul className="flex gap-2 my-2 ml-24">
                                    {user.reactions.map((emoji,i)=>(
                                        <li 
                                        onClick={()=>handle(emoji.emoji, user.id)}
                                        key={`reaction-${i}`}
                                        class={clx({'bg-gray-200 dark:bg-gray-700':emoji.voted},'px-2 rounded-full cursor-pointer border-gray-200 dark:border-zinc-700 border-2 flex items-center')}
                                        >
                                            <p className="">{emoji.emoji}</p> {emoji.count>1 && emoji.count}
                                        </li>
                                    ))}
                                    </ul>
                                )}
        
                            </li>
                        )})}
                    </ul>
                )}


            {messages.length==0 && delay && <Empty /> }
            {messages.length==0 && !delay && <Spinner /> }


            </div>
            {!profile && !search &&  <Send /> }
        </React.Fragment>
    )
  }

  export const Actions = ({id, handle}) => {
    const [status, setStatus] = useState(false)
    return (
      <div>
         <div className="hidden group-hover:flex items-center absolute right-0 -top-5 bg-white dark:bg-zinc-800 p-1 cursor-pointer rounded-full shadow-md border border-gray-300 dark:border-zinc-600 z-50 flex gal-1 text-xl">
                  <div onClick={()=>handle('👍', id)} className="hover:scale-125">👍</div>
                  <div onClick={()=>handle('😍', id)} className="hover:scale-125">😍</div>
                  <div onClick={()=>handle('😂', id)} className="hover:scale-125">😂</div>
                  <div onClick={()=>handle('😲', id)} className="hover:scale-125">😲</div>
                  <div onClick={()=>handle('😞', id)} className="hover:scale-125">😞</div>
                  <div onClick={()=>handle('😡', id)} className="hover:scale-125">😡</div>
                  <div onClick={()=>handle('👎', id)} className="hover:scale-125">👎</div>
  

                  <EmojiPicker
                    wrapper={ <div className="bg-gray-200 dark:bg-zinc-400 rounded-md mr-1 h-6 w-6 flex items-center justify-center"> <FiPlus className="dark:text-gray-600 text-gray-500 h-5" /> </div> }
                    right
                    />


              
  
              </div>
      </div>
    )
}
  
  